function FormInput({
                       label,
                       placeholder,
                       info,
                       setValue = () => null,
                       value,
                       prefix,
                       suffix,
                       type = "text",
                       maxLength = 32,
                       minLength = 0,
                       min, max, step,
                       required,
                       pattern,
                       disabled
                   }) {

    if (suffix || prefix)
        return (
            <div className="mb-3">
                <label className="form-label">{label}</label>

                <div className="input-group">
                    {
                        prefix ? (<span className="input-group-text">{prefix}</span>) : null
                    }
                    <input type={type} pattern={pattern} required={required} maxLength={maxLength} minLength={minLength}
                           className="form-control" placeholder={placeholder} disabled={disabled} value={value}
                           min={min} max={max} step={step}
                           onChange={e => setValue(type === "number" ? e.target.valueAsNumber : e.target.value)}/>
                    {
                        suffix ? (<span className="input-group-text">{suffix}</span>) : null
                    }
                </div>

                {
                    info ? (<div className="form-text">{info}</div>) : null
                }
            </div>
        )


    return (
        <div className="mb-3">
            {label ? (<label className="form-label">{label}</label>) : null}

            <input type={type} pattern={pattern} required={required} maxLength={maxLength} minLength={minLength}
                   className="form-control" placeholder={placeholder} disabled={disabled} value={value} min={min}
                   max={max} step={step}
                   onChange={e => setValue(type === "number" ? e.target.valueAsNumber : e.target.value)}/>
            {
                info ? (<div className="form-text">{info}</div>) : null
            }
        </div>
    )
}

export default FormInput